{
  "name": "intuitivemr",
  "version": "4.5.132",
  "description": "AZZLY Rize",
  "homepage": "http://www.azzly.com",
  "private": true,
  "sideEffects": [
    "*.css",
    "*.scss",
    "./src/app/**/index.ts",
    "./src/app/**/public-api.ts",
    "./src/polyfills.ts",
    "./node_modules/@angular/material/fesm2022/select.mjs",
    "./node_modules/@angular/material/fesm2022/tooltip.mjs"
  ],
  "scripts": {
    "build": "node --max_old_space_size=6144 node_modules/@angular/cli/bin/ng build intuitivemr --configuration production --progress",
    "build:stats": "node --max_old_space_size=6144 node_modules/@angular/cli/bin/ng build intuitivemr --configuration production --stats-json",
    "stats:analyze": "esbuild-visualizer --metadata ./dist/stats.json  --filename ./dist/stats.html --open true",
    "develop": "node --max_old_space_size=12288 node_modules/@angular/cli/bin/ng serve intuitivemr --port 3000",
    "develop:prod": "node --max_old_space_size=6144 node_modules/@angular/cli/bin/ng serve intuitivemr --configuration production --port 3000",
    "develop:portal": "node --max_old_space_size=12288 node_modules/@angular/cli/bin/ng serve portal --configuration local --port 4200",
    "develop:portal:preview": "node --max_old_space_size=12288 node_modules/@angular/cli/bin/ng serve portal --configuration preview --port 4200",
    "develop:portal:prestage": "node --max_old_space_size=12288 node_modules/@angular/cli/bin/ng serve portal --configuration prestage --port 4200",
    "develop:portal:production": "node --max_old_space_size=6144 node_modules/@angular/cli/bin/ng serve portal --configuration production --port 4200",
    "build:portal": "node --max_old_space_size=6144 node_modules/@angular/cli/bin/ng build portal --configuration production --progress",
    "build:portal:preview": "node --max_old_space_size=6144 node_modules/@angular/cli/bin/ng build portal --configuration preview --progress",
    "qa": "node --max_old_space_size=6144 node_modules/@angular/cli/bin/ng serve intuitivemr --aot --port 3000",
    "test": "jest --passWithNoTests",
    "test-develop": "jest --watch",
    "format": "prettier --write \"./src/**/*.{html,ts,js,json}\"",
    "format:ease": "prettier --write \"./src/app/ease/**/*.{html,ts,js,json}\" \"./src/app/shared/**/*.{html,ts,js,json}\" \"./src/app/core/**/*.{html,ts,js,json}\"",
    "lint": "eslint . --ext .ts",
    "lint:fix": "eslint . --ext .ts --fix",
    "lint:html": "eslint . --ext .html",
    "validate:i18n": "node scripts/validate-translations.js",
    "prepare": "husky install",
    "static-server": "npx serve -s ./dist/browser -l 8080",
    "storybook": "ng run intuitivemr:storybook",
    "build-storybook": "ng run intuitivemr:build-storybook",
    "e2e": "playwright test",
    "e2e:ui": "playwright test --ui",
    "e2e:headed": "playwright test --headed",
    "e2e:debug": "playwright test --debug",
    "e2e:codegen": "playwright codegen http://localhost:3000",
    "e2e:reports": "E2E_SKIP_CLINICAL_SEED=true playwright test e2e/tests/reports/embedded-report-renders.spec.ts --reporter=line --workers=1 --retries=0"
  },
  "dependencies": {
    "@angular/animations": "^19.2.19",
    "@angular/cdk": "^19.2.19",
    "@angular/common": "^19.2.19",
    "@angular/compiler": "^19.2.19",
    "@angular/compiler-cli": "^19.2.19",
    "@angular/core": "^19.2.19",
    "@angular/elements": "^19.2.19",
    "@angular/forms": "^19.2.19",
    "@angular/localize": "^19.2.19",
    "@angular/material": "^19.2.19",
    "@angular/material-moment-adapter": "^19.2.19",
    "@angular/platform-browser": "^19.2.19",
    "@angular/platform-browser-dynamic": "^19.2.19",
    "@angular/router": "^19.2.19",
    "@angularclass/hmr": "1.2.2",
    "@auth0/angular-jwt": "2.1.0",
    "@auth0/auth0-angular": "^2.5.0",
    "@auth0/auth0-spa-js": "^2.14.0",
    "@floating-ui/dom": "^1.7.4",
    "@formio/angular": "9.0.2",
    "@formio/js": "5.0.1",
    "@formio/premium": "3.0.3",
    "@fortawesome/fontawesome-free": "^6.5.1",
    "@fullcalendar/angular": "^6.1.20",
    "@fullcalendar/bootstrap": "^6.1.20",
    "@fullcalendar/core": "^6.1.20",
    "@fullcalendar/daygrid": "^6.1.20",
    "@fullcalendar/interaction": "^6.1.20",
    "@fullcalendar/moment-timezone": "^6.1.20",
    "@fullcalendar/resource": "^6.1.20",
    "@fullcalendar/resource-timegrid": "^6.1.20",
    "@fullcalendar/rrule": "^6.1.20",
    "@jsverse/transloco": "^8.2.0",
    "@microsoft/applicationinsights-angularplugin-js": "^15.3.8",
    "@microsoft/applicationinsights-web": "^3.3.10",
    "@ngxmc/datetime-picker": "^19.3.1",
    "@ngxs/store": "^19.0.0",
    "@progress/kendo-angular-buttons": "^23.1.0",
    "@progress/kendo-angular-common": "^23.1.0",
    "@progress/kendo-angular-dateinputs": "^23.1.0",
    "@progress/kendo-angular-dialog": "^23.1.0",
    "@progress/kendo-angular-dropdowns": "^23.1.0",
    "@progress/kendo-angular-excel-export": "^23.1.0",
    "@progress/kendo-angular-grid": "^23.1.0",
    "@progress/kendo-angular-icons": "^23.1.0",
    "@progress/kendo-angular-inputs": "^23.1.0",
    "@progress/kendo-angular-intl": "^23.1.0",
    "@progress/kendo-angular-l10n": "^23.1.0",
    "@progress/kendo-angular-label": "^23.1.0",
    "@progress/kendo-angular-layout": "^23.1.0",
    "@progress/kendo-angular-navigation": "^23.1.0",
    "@progress/kendo-angular-pager": "^23.1.0",
    "@progress/kendo-angular-pdf-export": "^23.1.0",
    "@progress/kendo-angular-popup": "^23.1.0",
    "@progress/kendo-angular-progressbar": "^23.1.0",
    "@progress/kendo-angular-toolbar": "^23.1.0",
    "@progress/kendo-angular-treeview": "^23.1.0",
    "@progress/kendo-angular-upload": "^23.1.0",
    "@progress/kendo-angular-utils": "^23.1.0",
    "@progress/kendo-data-query": "^1.7.3",
    "@progress/kendo-drawing": "^1.24.0",
    "@progress/kendo-licensing": "^1.10.1",
    "@progress/kendo-svg-icons": "^4.0.0",
    "@progress/kendo-theme-bootstrap": "^7.0.2",
    "@progress/kendo-theme-default": "^7.0.2",
    "@progress/telerik-angular-report-viewer": "^21.24.130",
    "@sentry/angular": "^8.55.0",
    "@tanstack/angular-table": "^8.21.3",
    "@types/qrcode": "^1.5.6",
    "@zoom/meetingsdk": "^5.0.2",
    "@zxing/browser": "^0.1.5",
    "@zxing/library": "^0.21.3",
    "@zxing/ngx-scanner": "^19.0.0",
    "ace-builds": "~1.4.1",
    "ajv": "^8.18.0",
    "angularx-qrcode": "^19.0.0",
    "assert": "^2.1.0",
    "bootstrap": "^5.3.2",
    "bootswatch": "4.4.1",
    "chart.js": "^4.5.1",
    "chartjs-adapter-date-fns": "^3.0.0",
    "core-js": "^3.39.0",
    "date-fns": "^4.1.0",
    "docx-preview": "^0.3.7",
    "driver.js": "^1.4.0",
    "exceljs": "^4.4.0",
    "fingerprintjs2": "~2.1.0",
    "formiojs": "^4.18.0",
    "hammerjs": "^2.0.8",
    "html2canvas": "^1.0.0-rc.7",
    "humanparser": "^1.11.0",
    "ipaddr.js": "1.9.1",
    "jquery": "^3.7.1",
    "jsonata": "^2.1.0",
    "jspdf": "^4.0.0",
    "jszip": "^3.10.1",
    "lucide-angular": "^0.556.0",
    "luxon": "~2.5.2",
    "marked": "^17.0.1",
    "md5": "~2.2.1",
    "microsoft-cognitiveservices-speech-sdk": "^1.49.0",
    "moment": "^2.30.0",
    "moment-timezone": "^0.5.43",
    "ng-multiselect-dropdown": "1.0.0",
    "ng-primitives": "^0.85.0",
    "ng2-charts": "^8.0.0",
    "ng2-cookies": "1.0.12",
    "ngx-bootstrap": "^19.0.2",
    "ngx-clipboard": "^16.0.0",
    "ngx-color-picker": "^16.0.0",
    "ngx-device-detector": "^9.0.0",
    "ngx-editor": "^17.0.2",
    "ngx-image-cropper": "^7.1.2",
    "ngx-quill": "^27.0.0",
    "ngx-webcam": "^0.4.1",
    "pdfjs-dist": "^4.10.38",
    "powerbi-client": "^2.23.1",
    "qrcode": "^1.5.4",
    "quill": "2.0.2",
    "renderjson": "~1.4.0",
    "rrule": "^2.2.0",
    "rxjs": "^7.0.0",
    "simple-line-icons": "^2.5.5",
    "socket.io-client": "^4.8.1",
    "symbol-observable": "^4.0.0",
    "tslib": "^2.6.2",
    "utif": "^3.1.0",
    "uuid": "^9.0.1",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-builders/custom-webpack": "^19.0.1",
    "@angular-eslint/eslint-plugin": "^19.8.1",
    "@angular-eslint/eslint-plugin-template": "^19.8.1",
    "@angular-eslint/template-parser": "^19.8.1",
    "@angular/build": "^19.2.21",
    "@angular/cli": "^19.2.19",
    "@angular/language-service": "^19.2.19",
    "@chromatic-com/storybook": "^3.2.7",
    "@ngxs/devtools-plugin": "^19.0.0",
    "@playwright/test": "^1.58.1",
    "@storybook/addon-essentials": "^8.6.14",
    "@storybook/addon-interactions": "^8.6.14",
    "@storybook/angular": "^8.6.14",
    "@storybook/blocks": "^8.6.14",
    "@storybook/test": "^8.6.14",
    "@types/babel__traverse": "^7.20.4",
    "@types/fingerprintjs2": "~2.0.0",
    "@types/hammerjs": "^2.0.45",
    "@types/html2canvas": "0.0.36",
    "@types/jest": "^29.5.11",
    "@types/jquery": "2.0.48",
    "@types/mssql": "^9.1.9",
    "@types/qrcode": "^1.5.6",
    "@types/rrule": "2.1.7",
    "@types/tapable": "^1.0.12",
    "@types/uglify-js": "2.6.29",
    "@types/utif": "^3.0.4",
    "@typescript-eslint/eslint-plugin": "^8.56.1",
    "@typescript-eslint/parser": "^8.56.1",
    "@typescript-eslint/utils": "^8.56.1",
    "autoprefixer": "^10.4.22",
    "cross-env": "^7.0.0",
    "dotenv": "^17.2.3",
    "esbuild-visualizer": "^0.7.0",
    "eslint": "^8.57.1",
    "eslint-plugin-playwright": "^2.9.0",
    "font-awesome": "4.7.0",
    "husky": "^7.0.0",
    "jest": "^29.1.0",
    "jest-preset-angular": "^14.6.2",
    "mssql": "^12.2.0",
    "postcss": "^8.5.6",
    "prettier": "^2.8.8",
    "pretty-quick": "^3.1.3",
    "storybook": "^8.6.14",
    "tailwindcss": "^3.4.18",
    "typescript": "5.5.4",
    "webpack": "^5.30.0",
    "webpack-bundle-analyzer": "^4.10.1"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/AZZLY/intuitivemr.git"
  },
  "bugs": {
    "url": "https://www.pivotaltracker.com/n/projects/1498318"
  },
  "engines": {
    "node": ">=20.0.0"
  },
  "overrides": {
    "ansi-styles@^6": "6.2.3",
    "jsdom": "^20.0.0",
    "tar": "^7.5.7"
  },
  "jest": {
    "preset": "jest-preset-angular",
    "setupFilesAfterEnv": [
      "./setupJest.ts"
    ],
    "roots": [
      "<rootDir>/src",
      "<rootDir>/e2e/helpers"
    ],
    "testPathIgnorePatterns": [
      "__tests__/helpers/",
      "__tests__/fixtures/"
    ],
    "modulePaths": [
      "<rootDir>/src"
    ],
    "transformIgnorePatterns": [
      "node_modules/(?!.*\\.mjs$|@jsverse)"
    ],
    "moduleNameMapper": {
      "^@shared/(.*)$": "<rootDir>/src/app/shared/$1",
      "^@core/(.*)$": "<rootDir>/src/app/core/$1",
      "^@modules/(.*)$": "<rootDir>/src/app/modules/$1",
      "^@ease/(.*)$": "<rootDir>/src/app/ease/$1",
      "^@ui/(.*)$": "<rootDir>/src/app/shared/components/ui/$1",
      "^@store/(.*)$": "<rootDir>/src/app/store/$1",
      "^@components/(.*)$": "<rootDir>/src/app/components/$1",
      "^app/(.*)$": "<rootDir>/src/app/$1",
      "^@models/(.*)$": "<rootDir>/src/models/$1",
      "^@RizeModels/(.*)$": "<rootDir>/src/models/$1"
    }
  }
}
